import React from "react";
import { Outlet } from "react-router-dom";

export function Layout(): React.ReactElement {
    return (
        <div className="min-h-screen bg-m-background">
            <main className="w-full max-w-7xl mx-auto px-4 md:px-6 pt-4 mb-8 sm:py-10">
                <Outlet />
            </main>
        </div>
    );
}
